// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-generation__container{height:auto;overflow-x:hidden;width:100%}`, "",{"version":3,"sources":["webpack://./src/library/pages/reportgeneratorpage.css"],"names":[],"mappings":"AAAA,8BAGI,WAAY,CADZ,iBAAkB,CADlB,UAGJ","sourcesContent":[".report-generation__container {\n    width: 100%;\n    overflow-x: hidden;\n    height: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
